// extracted by mini-css-extract-plugin
module.exports = {"Survey":"Survey_Survey__2ldJj","CloseButton":"Survey_CloseButton__ctN5T","PrevButton":"Survey_PrevButton__2fkSi"};